export default [
  {
    path: "/tutor-dashboard",
    name: "tutor-main",
    component: () =>
      import("../../modules/Tutor/pages/TutorDashboard/TutorDashboard.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["tutor"],
    },
  },
];
